// GetBasketRecommendations returns recommended products based in the product add to the basket
export const BasketRecommendationsService_GetBasketRecommendationsLazy = () =>
  import("./service.grpc").then(
    (m) => m.BasketRecommendationsService_GetBasketRecommendations
  );
BasketRecommendationsService_GetBasketRecommendationsLazy.method =
  "aysa_api.services.basket.v1.recommendations.BasketRecommendationsService/GetBasketRecommendations" as const;
